import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { ClickTracking } from '@/components/ClickTracking';
import { PlusIcon } from '@/icons';
import { type ReturnZepIcon } from '@/icons/ZepIcon';
import { useSearchQuizQuery } from '@/shared/quizList/hooks/useSearchQuizQuery';
import { type QuizListType } from '@/shared/quizList/QuizListType';
import { Button } from '@/ui_v3';
type EmptyQuizListProps = {
  type: QuizListType;
  title?: string;
  description?: string;
  goToActionInfo?: {
    href: string;
    icon: ReturnZepIcon;
    label: string;
    target: '_blank' | '_open';
  };
};
export const EmptyQuizList = (props: EmptyQuizListProps) => {
  const {
    searchText
  } = useSearchQuizQuery();
  const {
    t
  } = useTranslation(['common']);
  const goToActionInfo: EmptyQuizListProps['goToActionInfo'] = props.goToActionInfo ?? {
    target: '_blank',
    href: '/build',
    icon: PlusIcon,
    label: t('common.makeQuiz')
  };
  const GotoActionIcon = goToActionInfo.icon;
  const emptyText = searchText ? t('quizList.empty.bySearch') : t('quizList.empty.byFilter');
  return <div className={'flex flex-1 flex-col items-start justify-center py-2xl'} data-sentry-component="EmptyQuizList" data-sentry-source-file="EmptyQuizList.tsx">
      <div className={'flex w-full flex-col items-center justify-center gap-md'}>
        <div className={'flex flex-col items-center justify-center gap-xs'}>
          <img className={'aspect-[3/2] h-[128px] w-[192px] shrink-0'} src="/assets/empty_avatar.webp" alt={'mark'} />
          {searchText && <span className={'text-heading-md-bold text-default'}>
              {'"' + searchText + '"'}
            </span>}
          <span className={'text-heading-md-bold text-alternative'}>
            {props.title ? props.title : emptyText}
          </span>
          <span className={'text-body-lg-medium text-assistive'}>
            {props.description ? props.description : t('quizList.empty.suggestion')}
          </span>
        </div>
        <ClickTracking eventName={props.type === 'myQuiz' ? 'create_quiz_empty_myquiz' : 'create_quiz_empty_public'} data-sentry-element="ClickTracking" data-sentry-source-file="EmptyQuizList.tsx">
          <Button intent={'alternative'} variant={'outlined'} size={'lg'} rounded={'full'} asChild={true} data-sentry-element="Button" data-sentry-source-file="EmptyQuizList.tsx">
            <Link href={goToActionInfo.href} target={goToActionInfo.target} prefetch={false} data-sentry-element="Link" data-sentry-source-file="EmptyQuizList.tsx">
              <GotoActionIcon size={'md'} data-sentry-element="GotoActionIcon" data-sentry-source-file="EmptyQuizList.tsx" />
              {goToActionInfo.label}
            </Link>
          </Button>
        </ClickTracking>
      </div>
    </div>;
};